// Shared decorative SVGs used across the blue hero banners.
// These replace the previous emoji placeholders so every page matches
// the design mockups (dark horse silhouette + kufic calligraphy mark).

export function HorseSilhouette({
  className,
  style,
  color = '#04071c',
}: {
  className?: string
  style?: React.CSSProperties
  color?: string
}) {
  return (
    <svg
      className={className}
      style={style}
      viewBox="-20 -20 616 660"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fill={color}
        d="M575.9 26.6C572.5 11.1 558.7 0 542.8 0L448 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l46.4 0-50.9 81.4c-26.4-12-55.7-18.8-86.5-19.4l-1.2 0-160 0c-71.7 0-131.1 51.7-143.5 119.8C13.9 263.6 0 286.2 0 312l0 88c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-50.7c14.9 9 32.4 14.7 51.3 16.1L208 591.1c1.2 16.7 15.1 29.5 31.9 29.5l63.6 0c18.6 0 33.1-15.9 31.9-34.4L325.6 416l11.6 0L416 416l0 176c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-202.8c19.4-22.5 33.1-50.3 38.7-81L592.7 304c26.1 0 47.3-21.2 47.3-47.3 0-94.6-58.4-175.6-141.1-208.9l27.5-44C536.7 95.3 553 88 561.3 73.7L575.9 26.6z"
      />
    </svg>
  )
}

// Square-kufic style calligraphic mark (decorative), echoes the logo motif
// shown in the top-right of the about/business banners.
export function KuficMark({
  className,
  style,
  color = 'rgba(255,255,255,0.10)',
}: {
  className?: string
  style?: React.CSSProperties
  color?: string
}) {
  return (
    <svg
      className={className}
      style={style}
      viewBox="0 0 64 64"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* a symmetric square-kufic lattice */}
      <rect x="2" y="2" width="60" height="6" />
      <rect x="2" y="2" width="6" height="60" />
      <rect x="56" y="2" width="6" height="60" />
      <rect x="2" y="56" width="60" height="6" />
      <rect x="14" y="14" width="6" height="22" />
      <rect x="14" y="14" width="22" height="6" />
      <rect x="30" y="20" width="6" height="16" />
      <rect x="44" y="14" width="6" height="22" />
      <rect x="44" y="30" width="12" height="6" />
      <rect x="14" y="44" width="22" height="6" />
      <rect x="30" y="44" width="6" height="12" />
      <rect x="44" y="44" width="6" height="12" />
      <rect x="24" y="28" width="6" height="6" />
    </svg>
  )
}

// Chrome / glossy 3D "iq" robotic shape that sits bottom-right in the mockup.
export function ChromeShape({
  className,
  style,
}: {
  className?: string
  style?: React.CSSProperties
}) {
  return (
    <svg
      className={className}
      style={style}
      viewBox="0 0 160 120"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="chromeG" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="45%" stopColor="#e8edf5" />
          <stop offset="60%" stopColor="#9fb0c8" />
          <stop offset="100%" stopColor="#ffffff" />
        </linearGradient>
      </defs>
      {/* the loop of the 'g' */}
      <path
        d="M70 18c20 0 34 14 34 34 0 26-18 42-44 42-10 0-19-3-26-8l14-20c4 3 8 5 13 5 11 0 18-8 18-19 0-10-7-17-17-17-6 0-11 3-14 7V18z"
        fill="url(#chromeG)"
      />
      {/* the tall stroke */}
      <rect x="108" y="18" width="22" height="74" rx="10" fill="url(#chromeG)" />
      <circle cx="119" cy="8" r="9" fill="url(#chromeG)" />
    </svg>
  )
}
